import { ref, watch, watchEffect } from "vue";
import LlCheckbox from "@/components/LlCheckbox.vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import AssignDistributions from "./modals/AssignDistribution.vue";
import ListsService from "@/services/ListsService";
import { clearModalHack, getShortDateString } from "@/services/utils";
import { useDistributionStore } from "./store/useDistributionStore";
import { usePaymentStore } from "./store/usePaymentStore";
import { useDistributionNavigationStore } from "./store/useDistributionNavigationStore";
import { useUpdateDistributionStore } from "./store/useUpdateDistributionStore";
import PaymentsTimeFilterModal from "./modals/PaymentsTimeFilterModal.vue";
import Pagination from "@/components/Pagination.vue";
import Loader from "@/components/Loader.vue";
import LlTooltip from "@/components/LlTooltip.vue";
import MainHeader from "../../../components/MainHeader.vue";
export default {
  name: "BillingPayment",
  props: {
    alerts: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    modalService: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  components: {
    PaymentsTimeFilterModal,
    Pagination,
    Loader,
    AssignDistributions,
    LlCheckbox,
    LlSecondaryButton,
    LlTooltip,
    MainHeader
  },
  setup(props) {
    const loading = ref(true);
    const transactions = ref([]);
    const me = ref({});
    const pageSize = ref(20);
    const currPage = ref(1);
    const distributionNavigationStore = useDistributionNavigationStore();
    const distributionStore = useDistributionStore();
    const paymentStore = usePaymentStore();
    const updateDistributionStore = useUpdateDistributionStore();
    const checkedAll = ref(false);
    const query = ref("");
    paymentStore.alerts = props.alerts;
    distributionStore.alerts = props.alerts;
    updateDistributionStore.alerts = props.alerts;
    paymentStore.reloadPaymentParms();
    watchEffect(() => {
      transactions.value = paymentStore.paymentsList.payments;
    });
    watch(() => query.value, () => paymentStore.searchPayments(query.value));
    const getListPayments = async () => {
      loading.value = true;
      await paymentStore.listPayments();
      await distributionStore.listAllDistributions();
      me.value = await props.userService.getMe();
      transactions.value = paymentStore.paymentsList.payments;
      query.value = paymentStore.params.search;
      loading.value = false;
    };
    const distributionStatuses = new ListsService().distributionStatuses;
    const paymentStatues = new ListsService().paymentStatues;
    const getDistributionStatusLabel = statusId => {
      if (!statusId) {
        return " ";
      }
      const status = paymentStatues.find(s => s.id.toLowerCase() === statusId.toLowerCase());
      return status?.label;
    };
    function openPayment(payment) {
      window.open(payment.accounting.href);
    }
    function update(payments, isDistributed) {
      if (!payments) {
        payments = getSelectedPayments();
        if (!payments.length) {
          props.alerts.error("Pick one or more payments first.");
          return;
        }
      }
      payments.forEach(p => p.checked = true);
      if (isDistributed) {
        props.alerts.error("Cannot assign payment to a distribution that is locked.");
        return;
      }
      // assign new distribution
      distributionNavigationStore.toggleAssignDestributionModal(true);
    }
    function showAllocation(payment) {
      return props.modalService.showModal({
        template: require("../../modals/allocation/template.html"),
        inputs: {
          params: {
            payment
          }
        },
        bodyClass: "show-modal-overlay",
        controller: "AllocationModalController"
      }).then(modal => {
        modal.element.modal();
        clearModalHack();
        return modal.close.then(() => {});
      }, e => {
        console.error("Distribution date rejected:", e);
      });
    }
    async function removeDistribution(payment) {
      let isDistributed = false;
      let payments = [];
      let paymentIds = [];
      if (payment) {
        isDistributed = payment.distribution?.status === "Distributed";
        paymentIds.push(payment.id);
      } else {
        payments = transactions.value.filter(transaction => transaction.checked);
        isDistributed = payments.filter(payment => payment.distribution?.status === "Distributed").length;
        payments.forEach(payment => {
          paymentIds.push(payment.id);
        });
      }
      if (isDistributed) {
        props.alerts.error("Cannot assign payment to a distribution that is locked.");
        return;
      }
      await distributionStore.deleteDistributionPayments(paymentIds);
      getListPayments();
    }
    const openInvoice = invoice => {
      const url = `${props.leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf`;
      window.open(url);
    };
    const checkAll = checked => {
      const startIndex = pageSize.value * (currPage.value - 1);
      const lastIndex = pageSize.value * currPage.value;
      for (let i = startIndex; i < lastIndex; i++) {
        transactions.value[i].checked = checked;
      }
    };
    function updateMasterCheckbox() {
      checkedAll.value = allItemsCheckedOnCurrentPage();
    }
    function allItemsCheckedOnCurrentPage() {
      const startIndex = pageSize.value * (currPage.value - 1);
      const lastIndex = pageSize.value * currPage.value;
      const currentPageItems = transactions.value.slice(startIndex, lastIndex);
      return currentPageItems.every(i => i.checked);
    }
    function getSelectedPayments() {
      return transactions.value.filter(t => t.checked);
    }
    getListPayments();
    return {
      me,
      query,
      update,
      loading,
      checkAll,
      checkedAll,
      openPayment,
      openInvoice,
      paymentStore,
      transactions,
      showAllocation,
      distributionStore,
      getShortDateString,
      removeDistribution,
      distributionStatuses,
      updateMasterCheckbox,
      getDistributionStatusLabel,
      distributionNavigationStore
    };
  }
};